import { forwardRef, useState, useCallback, useMemo } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import IconPassword from "../../../../src/svgs/icon_password.svg";
import ErrorMessage from "./ErrorMessage";
import { usePreventContextMenu } from "@/hooks";
import IconCaution from "../../../../src/svgs/icon_caution.svg";

const PasswordField = forwardRef((props, ref) => {
  const { error, className, title, captionTop, caption, required, ..._props } = props;
  const [on, off] = usePreventContextMenu();
  const [toggleState, setToggleState] = useState(false);

  const handleClick = useCallback(() => {
    setToggleState(!toggleState);
  }, [toggleState]);

  const inputType = useMemo(() => {
    if (toggleState) return "text";
    if (!toggleState) return "password";
  }, [toggleState]);

  return (
    <div className={styles.inputField}>
      {title && (
        <legend
          className={classnames(styles.formTitle, {
            [styles.required]: required,
          })}
        >
          {title}
        </legend>
      )}
      {captionTop && (
        <p className={styles.textInputCaption}>
          {captionTop}
        </p>
      )}
      <div className={styles.hiddenPass}>
        <input
          ref={ref}
          type={inputType}
          name="password"
          className={classnames(
            styles.textInput,
            styles.passwordInput,
            className,
            { [styles.error]: error }
          )}
          defaultValue=""
          required={required}
          onFocus={off}
          onBlur={on}
          {..._props}
        />
        <span className={styles.iconPassword}>
          <IconPassword />
        </span>
        <span
          className={classnames(styles.passwordTogle, {
            [styles.eyeOff]: toggleState,
          })}
          onClick={handleClick}
        />
      </div>
      {caption && (
        <p className={styles.caption}>
          <span className={styles.iconCaution}>
            <IconCaution />
          </span>
          {caption}
        </p>
      )}
      {error && <ErrorMessage msg={error} />}
    </div>
  );
});
PasswordField.displayName = "PasswordField";
export default PasswordField;
